import React from 'react';
import cx from 'classnames';
import { useIntl, defineMessages } from 'react-intl';
import { Card, Header } from 'semantic-ui-react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Button, ListingImage } from '@package/components';

const messages = defineMessages({
  bando: { id: 'prj_listing_bando', defaultMessage: 'Bando' },
  contributo: { id: 'prj_listing_contributo', defaultMessage: 'Contributo' },
  ente: { id: 'prj_listing_ente', defaultMessage: 'Ente' },
  go_to_project: {
    id: 'prj_link_title_default',
    defaultMessage: 'Vai al progetto',
  },
});

const ProjectCard = (props) => {
  const {
    title,
    have_description,
    description,
    have_image,
    have_cta,
    cardLinkHref,
    cardLinkTitle,
  } = props;
  const intl = useIntl();
  let image = have_image
    ? ListingImage({ item: props, className: 'item-image' })
    : null;

  let cardClass = cx('item project-card', {
    'simple-card': true,
    'with-image': image != null,
  });

  let link = (
    <Button
      as={UniversalLink}
      size="large"
      href={cardLinkHref ? flattenToAppURL(cardLinkHref) : null}
      item={cardLinkHref ? null : props}
      arrow={true}
    >
      {cardLinkTitle ??
        cardLinkHref ??
        intl.formatMessage(messages.go_to_project)}
    </Button>
  );

  return (
    <Card className={cardClass}>
      {image}
      <div className="item-header">
        {props.titolo_bando && (
          <div className="values bando">
            <span className="label">{intl.formatMessage(messages.bando)}</span>{' '}
            <span>{props.titolo_bando}</span>
          </div>
        )}
        <Header as="h4">
          <UniversalLink item={props}>{title}</UniversalLink>
        </Header>
        {props.contributo_deliberato_fc && (
          <div className="values contributo">
            <span className="label">
              {intl.formatMessage(messages.contributo)}:
            </span>
            <span>
              {intl.formatNumber(props.contributo_deliberato_fc, {
                style: 'currency',
                currency: 'EUR',
                minimumFractionDigits: 0,
              })}
            </span>
          </div>
        )}
      </div>
      {have_description && <p className="item-text">{description}</p>}

      {props.organizzazione_po && (
        <div className="item-text values ente">
          {' '}
          <span className="label">
            {intl.formatMessage(messages.ente)}
          </span>{' '}
          <span>{props.organizzazione_po}</span>
        </div>
      )}
      {have_cta && <div className="item-button">{link}</div>}
    </Card>
  );
};

ProjectCard.propTypes = {
  title: PropTypes.string.isRequired,
  have_description: PropTypes.bool,
  description: PropTypes.string,
  have_image: PropTypes.bool,
  have_cta: PropTypes.bool,
  image: PropTypes.any,
  linkHref: PropTypes.string,
  linkTitle: PropTypes.string,
  isEditMode: PropTypes.bool,
};

export default ProjectCard;
